export default "__VITE_ASSET__BN9NjPaE__"